import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { LicenseCheckDisplayData } from "@/pages/license-check-admin/models/LicenseCheckDisplayData";

export function ResultCell(props: GridRenderCellParams<LicenseCheckDisplayData>) {
  if (props.value === "---") {
    return <>{props.value}</>;
  }
  return (
    <Tooltip title={props.value}>
      <Chip label={props.value} />
    </Tooltip>
  );
}
